app.service('basketView', function (console, orderUtils, partnerSubscriptionManager, pageConfig,
	basketServices, basketWarranty, broker, basketProduct, basketUtils, basketAnalytics, basketServiceReminder,
	basketDeliveryUnavailable, basketRetrieveCart, basketHomeDelivery, relatedAccessories, instalmentOrderAction,
	loading, validate, modal, basketVoucher, simpleToastr, message, expandableMessage,
	warrantyQuestionnaire, cartManager, allAccesoriesModal, partnerInsurance, instalmentCalculatorModal,
	operatorMaxWorthCalculator, goBack, callback) {
	var $self, $path, $deliveryType, $orderRequireActionModal, $shopPaymentType;
	var config, basket;
	let isOneInit = false;
	
	function next(forcedPartnerMode = false) {
		console.log('DALEJ NA KOSZYKU');
		if(basketVoucher.check(next)){
			return;
		}
		if ($form.valid()) {
			if(config.isOperatorMode) {
				if(!warrantyQuestionnaire.updateWarrantyQuestionnaireBeforeSent()){
					return false;
				}
			}
			if (config.isPartnerMode && forcedPartnerMode == false) {
				if (!partnerInsurance.checkNext(function () { 
					next(true);
				})) {
					return false;
				}
			}
			basketAnalytics.sendWarrantyAndServicesUA();
			if (config.instalmentOrdersRequiringNext && $orderRequireActionModal.length) {
				instalmentOrderAction.open();
			} else if (config.showNotAddedServices) {
				basketServiceReminder.open();
			} else {
				basketUtils.needRefresh(function () {
					if (checkCart()) {
						send();
					}
				});
			}
		}
	}
	
	function closeInstalmentOrdersAction() {
		if (config.instalmentOrdersRequiringNext) {
			config.instalmentOrdersRequiringNext = false;
			next();
		}
	}
	function send() {
		orderUtils.send('CREATE_ORDER');
	}
	function back() {
		goBack.go();
	}
	function checkCart() {
		if (config.serviceNotify) {
			console.log('POTYKACZ USŁUG');
			basketDeliveryUnavailable.open();
			return false;
		}
		else if (config.promoteDelivery) {
			console.log('POTYKACZ DOSTAWY');
			basketHomeDelivery.open();
			return false;
		} else {
			return true;
		}
	}
	function showMessages() {
		if (config.messages && config.messages.length) {
			$(config.messages).each(function (i, message) {
				console.log('komunikat: ' + message.type);
				modal.addMessage(message.content, message.type);
			});
			config.messages = [];
			modal.showMessages();
		}
	}
	function reloadCartSuccess(html, deliveryType = null) {
		modal.removeRemodals();
		if (html.indexOf('"order-path"') > -1) {		// cart.bhtml jako odpowiedź
			var $html = $('<div>' + html + '</div>');
			$path.html($html.find('#order-path').html());
			$self.html($html.find('#container').html());
		} else if (html.indexOf('<article>') > -1) {	// cart-only-body.bhtml jako odpowiedź
			$self.html(html);
		} else {
			$self.find('article').html(html);		// DO wyjaśnienia czy taki warunek faktycznie istnieje i jest potrzebny
		}

		init();
		UA.pageview();
		if (deliveryType !== null) {
			setDeliveryType(deliveryType);
		}
		if (config.isOperatorMode) {
			warrantyQuestionnaire.markAnswers();
		}
		loading.stop();
		broker.trigger('RELOAD_CART_SUCCESS');
		broker.trigger('WDIO-PAGE-REFRESH');
		callback.run('BASKET_RELOAD');
	}

	var isBasketRelaod = false;
	function reloadCartView(callback) {
		if (!isBasketRelaod) {
			isBasketRelaod = true;
			loading.start();
			$('#F_ACTION').val('REFRESH');
			$.ajax({
				cache: false,
				url: '/cart-only-body.bhtml',
				data: $form.serialize(),
				type: 'POST',
				success: function (html) {
					reloadCartSuccess(html);
					isBasketRelaod = false;
					if(callback){
						callback();
					}
				},
				error: function () {
					loading.stop();
					modal.alert('Wystąpił błąd przeładowania koszyka. Spróbuj ponownie odświeżyć koszyk');
					isBasketRelaod = false;
				}
			});
		}
	}
	function reloadDelivery(action, deliveryType, callback) {
		basketUtils.needRefresh(function () {
			basketUtils.incBacks();
			if (action) {
				$('#F_ACTION').val(action);
			}
			var data = $form.serializeArray();
			if(action && deliveryType == 0 || deliveryType == 1){
				data.forEach(function(e){
					if(e.name == 'deliveryType'){
						e.value = ""+deliveryType;
					} else if(deliveryType == 0 && e.name == 'shopDeliveryOptionType'){
						e.value = e.value;
					} else if(deliveryType == 1 && e.name == 'shopDeliveryOptionType'){
						e.value = "";
					}
				})
			}
			$.ajax({
				cache: false,
				url: '/cart.bhtml',
				data: data,
				type: 'POST',
				success: function (html) {
					reloadCartSuccess(html, deliveryType);
					if (callback) {
						callback();
					}
				},
				error: function () {
					loading.stop();
					modal.alert('Wystąpił błąd przeładowania koszyka. Koszyk zostanie przeładowany', function(){
						loading.reload();
					});
				}
			});
		});
	}
	function setShopPaymentType(deliveryType) {
		$shopPaymentType.val(deliveryType);
	}
	function updateDeliveryType(deliveryType, callback) {
		reloadDelivery('CHANGE_DELIVERY_TYPE', deliveryType, callback);
	}
	function setDeliveryType(deliveryType) {
		config.deliveryType = parseInt(deliveryType);
		if(config.deliveryType !== 0){
			setShopPaymentType("");
		}
		$deliveryType
			.filter('[value=' + deliveryType + ']')
			.filter(checkIfShopDeliveryMatchesPaymentOnline)
			.prop('checked', true);
	}
	function checkIfShopDeliveryMatchesPaymentOnline() {
		if (config.deliveryType === 0) {
			return $(this).data('shop-payment-type') === config.shopDeliveryOptionType;
		}
		return true;
	}
	var viewedPromotionProposals = [];
	function setPromotionProposalsUA() {
		var $promotionProposals = $('.promotion-proposal');
		if ($promotionProposals.length > 0) {
			$promotionProposals.each(function (i, el) {
				var promotionName = $(el).find('.promotion-name').text();
				var promotionUrl = $(el).find('.js-check-promotion').attr('href');
				if (!viewedPromotionProposals.includes(promotionName)) {
					UA.push({
						'event': 'view_promotion',
						'promotion_name': promotionName,
						'creative_name': 'Promocja na koszyku',
						'promotion_url': promotionUrl,
					});
					viewedPromotionProposals.push(promotionName);
				}
				$(el).on('click', '.js-check-promotion', function (e) {
					UA.push({
						'event': 'click_promotion',
						'promotion_name': promotionName,
						'creative_name': 'Promocja na koszyku',
						'promotion_url': promotionUrl,
					});
				});
			})
		}
	}
	function setElements() {
		$self = $('#basket #container');
		console.log('INIT BASKET', $self);
		$form = $('form', $self);
		$path = $('#order-path');
		$deliveryType = $('.js-delivery-type', $form);
		$orderRequireActionModal = $('#modal-instalment-orders-requiring-actions');
		$shopPaymentType = $('#shop-payment-type');
		config = pageConfig.getData('order');
		basket = pageConfig.getData('basket');
	}

	function showMaxCountMessage(maxCount) {
		var ending = maxCount == 1 ? 'sztukę' : (maxCount < 5 || (maxCount > 20 && maxCount % 10 >= 2 && maxCount % 10 < 5)) ? 'sztuki' : 'sztuk';
		var headerHtml = `Możesz kupić maksymalnie ${maxCount} ${ending} tego produktu`;
		let messageCode = 'cart-max-product-count-message';
		if (config.isOperatorMode) {
			messageCode = 'cart-max-product-count-message - tryb operatorski';
		} else if(config.isPartnerMode){
			messageCode = 'cart-max-product-count-message - tryb partnerski';
		}

		message.get(messageCode).then(function (result) {
			modal.generate({
				id: 'modal-product-max-count',
				header: headerHtml,
				content: result
			});
		});
	}
	function isProductInstallmentPrice(productId){
		return basket.items.filter(item => item.id == productId / 1)[0].isInstalmentPrice
	}

	function setEvents() {
		relatedAccessories.init();
		if (config.isOperatorMode) {
			warrantyQuestionnaire.init();
		}
		$('.js-increase-product', $self).click(function () {
			const $input = $(this).prev();
			const value = parseInt($input.val()) + 1;
			const productId = $input.data('product');
			const max = $input.data('max') / 1;
			if (value > max) {
				showMaxCountMessage(max);
				$input.val(max);
			} else {
				$input.val(value);
				basketProduct.increase(value, productId);				//tylko RWD
			}
		});

		$('.js-decrease-product', $self).click(function () {
			const $input = $(this).next();
			const value = parseInt($input.val() - 1);
			$input.val(value);
			const productId = $input.data('product');
			basketProduct.decrease(value, productId);				//tylko RWD
		});

		$('.js-increase-partner-subscription-standalone-service', $self).click(function () {
			const $input = $(this).prev();
			const quantity = parseInt($input.val()) + 1;
			$input.val(quantity);
			const productId = $input.data('product-id');
			cartManager.updatePartnerSubscriptionStandaloneServiceQuantity({
				productId,
				quantity
			});
		});

		$('.js-decrease-partner-subscription-standalone-service', $self).click(function () {
			const $input = $(this).next();
			const quantity = parseInt($input.val()) - 1;
			$input.val(quantity);
			const productId = $input.data('product-id');
			cartManager.updatePartnerSubscriptionStandaloneServiceQuantity({
				productId,
				quantity
			});
		});

		function enableAutoVouchers() {
			loading.start();
			return $.ajax({
				method: 'POST',
				url: '/enableAutomaticVouchers.ltr',
				success: function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				},
				error: function () {
					modal.alert('Błąd aktywacji. Spróbuj ponownie po odświeżeniu');
				}
			});
		}
		function disableAutoVouchers() {
			loading.start();
			$.ajax({
				method: 'POST',
				url: '/disableAutomaticVouchers.ltr',
				success: function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				},
				error: function () {
					modal.alert('Błąd deaktywacji. Spróbuj ponownie po odświeżeniu');
				}
			});
		}


		$('.js-enable-auto-vouchers', $self).click(function () {
			enableAutoVouchers();
		});
		$('.js-disable-auto-vouchers', $self).click(function () {
			disableAutoVouchers();
		});

		$('.js-warranty-add', $self).click(function (event) {
			let $button = $(this).closest('.warranty');
			basketWarranty.add({
				mainCartItemId: $button.data('cart-id'),
				warrantyId: $button.data('id'),
				packageIdentifier: $button.data('package-identifier'),
				relatedPromotionIdentifier: $button.data('related-promotion-identifier'),
				warrantyPaymentType: $button.data('type'),
				productPlu: $button.data('product-plu'),
				isProductInstallmentPrice: isProductInstallmentPrice($button.data('product-id')),
				place: 'promoted_warranty'
			});
			event.preventDefault();
			event.stopPropagation();
		});

		$('.js-warranty-edit', $self).click(function (event) {
			if (!event.target.closest(`.js-show-tooltip`)) {
				var $this = $(this);
				const gradeInfoFromCartElement = event.target.closest('.js-warranty-grades-info-from-cart');
				const showGradeInfoFromCart = gradeInfoFromCartElement ? true : false;
				const categoryGradeInfoFromCart = $(gradeInfoFromCartElement).data('warranty-category');
				basketWarranty.open({
					productId: $this.data('product-id'),
					productPlu: $this.data('product-plu'),
					packageIdentifier: $this.data('package-identifier'),
					relatedPromotionIdentifier: $this.data('related-promotion-identifier'),
					mainCartItemId: $this.data('cart-id'),
					variant: $this.data('type'),
					defaultSelectedWarranty: !$this.hasClass('selected') && !$(event.target).closest(`.js-modal-warranty-info`).length ? $this.data('id') : false,
					showGradeInfoFromCart: showGradeInfoFromCart,
					categoryGradeInfoFromCart: categoryGradeInfoFromCart,
					isProductInstallmentPrice: isProductInstallmentPrice($this.data('product-id'))
				});
				if (showGradeInfoFromCart) {
					UA.interaction('Koszyk - K1', 'Gwiazdki przy wariancie PG', 'Kliknięcie');
				}
			}
		});

		$('.js-load-partner-subscriptions', $self).click(function (event) {
			partnerSubscriptionManager.load({
				group: $(this).data('group'),
				product: $(this).data('product'),
				productPlu: $(this).data('product-plu'),
				relatedPromotionIdentifier: $(this).data('related-promotion-identifier'),
				added: $(this).data('added').split('|').map(item => {
					return { id: item.slice(0, item.indexOf(':')), quantity: Number(item.slice(item.indexOf(':') + 1)) }
				})
			});
			event.preventDefault();
		});
		$('.js-dependent-product-modal', $self).click(function () {
			modal.generate({
				id: 'dependent-product-modal',
				content: $('#basket-dependent-product-' + $(this).data('product')).html(),
				modifier: 'remodal-full-width'
			});
		});

		setPromotionProposalsUA();

		$('.js-subscription-tooltip').on('click', function (event) {
			const tooltipHtml = $(this).next('.js-warranty-period-info-subscription').html();
			modal.alert(tooltipHtml);
			event.stopPropagation();
		});

		$('.js-confirm-delete-esd', $self).on('click', function () {
			basketProduct.remove($(this).data('product'));
		});

		$('.js-show-warranties', $self).on('click', function (event) {
			app.logEvent({
				"id": "Przedluz gwarancje K1",
				"f03": "Wiecej o ubezpieczeniu",
				"f04": $(this).data('warranty-type') == 'ONE_TIME' ? "Płatność jednorazowa" : "Płatność miesięczna",
				"f05": ""
			});
		});

		$('.js-basket-next', $self).on('click', function () {
			next();
		});
		$('.js-basket-back', $self).on('click', function () {
			back();
		});
		$('.js-delete-product', $self).on('click', function () {
			basketProduct.remove($(this).data('product'));
		});
		$('.js-delete-suite', $self).on('click', function () {
			basketProduct.removeSuite($(this).data('suite'));
		});


		$('.js-change-quantity', $self).change(function () {
			const value = $(this).val() / 1;
			const productId = $(this).data('product');
			const quantity = $(this).data('quantity') / 1;
			const max = $(this).data('max') / 1;
			if (value > 0 && value <= max) {
				basketProduct.change(value, productId);
			} else if (value > max) {
				showMaxCountMessage(max);
				$(this).val(quantity);
			} else {
				$(this).val(quantity);
			}
		});
		$('.js-change-partner-subscription-quantity', $self).change(function () {
			const quantity = $(this).val();
			const productId = $(this).data('product');
			const partnerSubscriptionId = $(this).data('partner-subscription');

			cartManager.updatePartnerSubscriptionQuantity({
				productId,
				partnerSubscriptionId,
				quantity
			});
		});
		$('.js-change-partner-subscription-standalone-service-quantity', $self).change(function () {
			const quantity = $(this).val();
			const productId = $(this).data('product-id');
			cartManager.updatePartnerSubscriptionStandaloneServiceQuantity({
				productId,
				quantity
			});
		});
		$('.js-delete-partner-subscription', $self).click(function () {
			loading.start();
			const productId = $(this).data('product');
			const partnerSubscriptionId = $(this).data('partner-subscription');

			cartManager.removePartnerSubscription({
				productId,
				partnerSubscriptionId
			});
		});

		$('.js-all-accessories-modal', $self).on('click', function () {
			allAccesoriesModal.open($(this).data('product-id'), $(this).data('link'));
		});

		expandableMessage.init();

		$('.js-change-service-quantity', $self).on('change', function () {
			const quantity = $(this).val();
			const mainItemId = $(this).data('main-item-id');
			const serviceId = $(this).data('service');

			basketServices.change({
				mainItemId,
				serviceId,
				quantity
			});
		});
		$('.js-delete-service', $self).on('click', function (e) {
			basketServices.remove($(this).data('main-item-id'), $(this).data('service'));
			e.preventDefault();
		});
		$('#modal-delete-service-message .js-confirm-delete-service').on('click', function () {
			basketServices.confirmRemove();
		});

		$('.js-services-group', $self).on('click', function (event) {		// RWD
			basketServices.open({
				mainItemId: $(this).data('main-item-id') / 1,
				productId: $(this).data('product-id') / 1,
				productPlu: $(this).data('product-plu') / 1,
				index: $(this).data('index') / 1,
				added: ('' + $(this).data('added')).split('|').map((element) => {
					var elementSplit = element.split(':');
					return { id: elementSplit[0], quantity: elementSplit[1], plu: elementSplit[2] };
				}),
				paymentType: basket.items.filter(item => item.id == $(this).data('product-id') / 1)[0].isInstalmentPrice ? 'installment' : 'cash',
			});
			event.preventDefault();
		});

		$('.js-service-description', $self).on('click', function (event) {					// RWD
			basketServices.info($(this).data('service'), $(this).data('product'));
			event.preventDefault();
			event.stopPropagation();
		});

		$('.js-change-warranty-quantity', $self).on('change', function () {
			const value = $(this).val();
			const mainItemId = $(this).data('main-item-id');
			basketWarranty.change(value, mainItemId);
		});

		$('.js-product-controls input.js-quantity', $self).on('change', function () {
			basketUtils.calculateCart();
		});

		$('.js-show-more-services').on('click', function () {
			$(this).closest('.product-item').toggleClass('full-list');
		});
		$('#modal-basket-services-changed').on('closed', function () {
			send();
		});

		$deliveryType.on('click', function () {
			setShopPaymentType($(this).data('shop-payment-type'));
			updateDeliveryType($(this).val());
		});
		validate.task('basket');
	}

	function removeWrongServices(callback){
		console.log('Usuwanie niezgodnych usług');
		basketUtils.needRefresh(function () {
			loading.start();
			$.ajax({
				url: '/cartActions.ltr',
				method: 'post',
				data: {
					action: 'REMOVE_INVALID_SERVICES',
					//deliveryType: daliveryType		// nie wysyłać deliveryType gdy usuwamy usługi z obecną dostawą
				},
				success: function () {
					if(callback){
						callback();
					}
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd usuwania usług. Strona zostanie odświeżona', function () {
						loading.reload();
					})
				}
			});
		});
	}

	function init() {
		console.log('INIT BASKET');
		setElements();
		setEvents();
		if (!isOneInit) {
			broker.on('REFRESH_BASKET_VIEW', function () {
				reloadCartView();
			});
			broker.on('SUBMIT_BASKET_VIEW', function () {
				let $form = $('#container form:eq(0)');
				loading.start();
				$form.ajaxSubmit({
					success: function (html) {
						reloadCartSuccess($('<div>' + html + '</div>').find('#container').html());
					},
					error: function(){
						modal.alert('Wykonanie operacji okazało się niemożliwe. Strona zostanie przeładowana. Spróbuj ponownie', function(){
							loading.reload();
						});
					}
				});
			});
			broker.on('CONFIRM_HOME_DELIVERY', function () {
				// Zamów do domu, z usługami															// to podejście zostało czasowo zlikwidowane, nowe robi tylko jednego posta przez co jest wydajniejsze. Jeśli nowe się sprawdzi to będzie można stare posprzątać
				// reloadDelivery('CHANGE_DELIVERY_TYPE', 1, function(){	// akcja zmiany dostawy
				// 	next();												// wysyła ponownie koszyk	
				// });
				$deliveryType.prop('checked', false).filter('[value=1]').prop('checked', true);
				setShopPaymentType('');
				orderUtils.send('CHANGE_DELIVERY_TYPE_AND_CREATE_ORDER');
				
			});
			broker.on('RESIGN_HOME_DELIVERY', function () {
				// Zarezerwuj w sklepie, z usługami														// to podejście zostało czasowo zlikwidowane, nowe robi tylko jednego posta przez co jest wydajniejsze. Jeśli nowe się sprawdzi to będzie można stare posprzątać
				// reloadDelivery('CHANGE_DELIVERY_TYPE', 0, function(){	// akcja zmiany dostawy
				// 	next();												// wysyła ponownie koszyk	
				// });
				$deliveryType.prop('checked', false);
				let $shop = $('label:visible .js-delivery-type').filter('[value=0]').not(':disabled').first();
				$shop.prop('checked', true);
				setShopPaymentType($shop.data('shop-payment-type'));
				orderUtils.send('CHANGE_DELIVERY_TYPE_AND_CREATE_ORDER');
			});
			broker.on('DECLINE_HOME_DELIVERY', function () {
				// Zamów do domu, bez usług
				removeWrongServices(function(){		// usuwa złe usługi
					reloadCartView(function(){		// odświeża stan koszyka
						next();						// wysyła ponownie koszyk
					})
				})
			});
			
			broker.on('ORDER-NEXT-STEP', function () {
				if(config.pageType == 'basket'){
					next();
				}
			});
			isOneInit = true;
			$('body').on('click', '.js-service-change-confirm', function (event) {					// RWD
				basketServices.save();
				event.preventDefault();
			}).on('click', '.js-add-dependent-product', function (event) {						// RWD
				modal.close();
				cartManager.simpleAddProduct({
					productId: $(this).data('product')
				}, function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				});
			}).on('click', '.js-service-change-more', function (event) {						// RWD
				$(this).closest('.service-item').toggleClass('extended');
				event.stopPropagation();
				event.preventDefault();
			}).on('click', '.js-show-instalment-calculator', function () {
				instalmentCalculatorModal.open();
			});
		}
		operatorMaxWorthCalculator.init();
		partnerInsurance.init();
		basketVoucher.init();
		basketServiceReminder.init();
		basketRetrieveCart.init();
		basketHomeDelivery.init();
		basketDeliveryUnavailable.init();
		instalmentOrderAction.init(closeInstalmentOrdersAction);
		if (config.esdDelayed) {
			modal.open('esd-delayed-message');
		} else if (config.showInvalidItemWithIncludedPackageItemsMessage) {
			modal.open('invalid-package-items-included');
		} else if (config.showCartPopupMessage) {
			modal.open('cart-popup-message');
		}
		UA.push({
			positions: config.pluQuantity,
			products: config.productsQuantity
		});
		showMessages();

		if (config.voucherErrorMessage.length) {
			simpleToastr.generate(config.voucherErrorMessage, {
				closeOthers: true,
				modifier: 'warning'
			});
		} else if (config.voucherInfoMessage.length) {
			simpleToastr.generate(config.voucherInfoMessage, {
				closeOthers: true
			});
		}
	}

	return {
		init,
		next
	};
});
